import React, { useLayoutEffect, useRef } from 'react';
import { cx } from './cx';
import { fieldControlClass } from './Input';

export interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  /** Grow with the content up to the max height set by className. */
  autoGrow?: boolean;
}

/** Multi-line text input matching Input. */
const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
  { invalid, autoGrow = false, className, value, ...rest },
  ref
) {
  const inner = useRef<HTMLTextAreaElement | null>(null);
  useLayoutEffect(() => {
    const el = inner.current;
    if (!autoGrow || !el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }, [autoGrow, value]);
  return (
    <textarea
      ref={(el) => {
        inner.current = el;
        if (typeof ref === 'function') ref(el);
        else if (ref) ref.current = el;
      }}
      value={value}
      aria-invalid={invalid || rest['aria-invalid'] || undefined}
      className={cx(
        fieldControlClass,
        'min-h-24 resize-y px-3 py-2.5 leading-6',
        invalid ? 'border-danger' : 'border-edge hover:border-edge-strong',
        className
      )}
      {...rest}
    />
  );
});

export default TextArea;
